export enum eCrowdednessType {
    LIGHT = 1,
    MEDIUM,
    HEAVY
}